/**
 * Zákazníci — fáze (segmenty). Prahy jsou v `ZakazniciController`
 * (`zakladSeznamu`, `fazePhp`), tady jen popisky. Měnit obojí.
 */
import { CERVENA, SECTION_COLOR } from '../objednavky/ui';

export const FAZE = {
    novacek: { label: 'Nováček', popis: 'první objednávka za posledních 30 dní' },
    vracejici: { label: 'Vracející se', popis: '2–3 objednávky za 12 měsíců' },
    staly: { label: 'Stálý', popis: '4–9 objednávek za 12 měsíců' },
    fanousek: { label: 'Fanoušek', popis: '10 a víc objednávek za 12 měsíců' },
    ohrozeny: { label: 'Ohrožený', popis: '3+ objednávky za rok, ale 45 dní nic' },
    jednorazovy: { label: 'Jednorázový', popis: 'jedna objednávka za rok' },
    ztraceny: { label: 'Ztracený', popis: 'poslední objednávka před víc než rokem' },
    bez_objednavky: { label: 'Bez objednávky', popis: 'v evidenci, ale bez platné objednávky' },
};

/** Pohledy seznamu (norma §2: pilulky, do šesti). */
export const POHLEDY = [
    { id: 'vsichni', label: 'Všichni' },
    { id: 'fanousci', label: 'Fanoušci' },
    { id: 'stali', label: 'Stálí' },
    { id: 'vracejici', label: 'Vracející se' },
    { id: 'novi', label: 'Noví' },
    { id: 'ohrozeni', label: 'Ohrožení', upozorneni: true },
];

export function predDny(dni) {
    if (dni == null) return '—';
    if (dni === 0) return 'dnes';
    if (dni === 1) return 'včera';
    if (dni < 60) return `před ${dni} dny`;
    const mes = Math.round(dni / 30);
    return mes < 12 ? `před ${mes} měs.` : `před ${Math.round(dni / 365)} r.`;
}

/** Fáze jako pilulka — ohrožený červeně (jediný stav, na který se má reagovat), jinak neutrálně. */
export function FazeOdznak({ faze, isDark }) {
    const f = FAZE[faze] || { label: faze };
    const cervena = faze === 'ohrozeny';
    return (
        <span title={f.popis || ''} style={{
            fontSize: 10.5, fontWeight: 600, padding: '2px 8px', borderRadius: 999, whiteSpace: 'nowrap', display: 'inline-block', lineHeight: '16px',
            color: cervena ? CERVENA : 'var(--text-secondary)',
            background: cervena ? `${CERVENA}18` : (isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.045)'),
            border: `1px solid ${cervena ? `${CERVENA}33` : (isDark ? 'rgba(255,255,255,0.10)' : 'var(--border-default)')}`,
        }}>{f.label}</span>
    );
}

/** Položky „K dořešení" pro panel i mobilní modal (norma §1g) — z jednoho přehledu. */
export function kDoreseniZakazniku(prehled) {
    if (!prehled) return [];
    const p = [];
    for (const o of prehled.ohrozeni || []) {
        p.push({
            id: `ohrozeny-${o.id}`, zakaznikId: o.id, problem: false,
            titulek: `${o.jmeno || 'bez jména'} — ${o.dni} dní nic`,
            popis: `ohrožený · ${Math.round(o.utrata_12m).toLocaleString('cs-CZ')} Kč za 12 měsíců`,
        });
    }
    for (const d of (prehled.duplicity || []).slice(0, 5)) {
        p.push({
            id: `dup-${d.ids.join('-')}`, zakaznikId: d.ids[0], problem: false,
            titulek: `Možná jeden člověk (${d.podle})`,
            popis: d.jmena,
        });
    }
    if (prehled.bez_kontaktu > 0) {
        p.push({ id: 'bezkontaktu', problem: false, titulek: `${prehled.bez_kontaktu} zákazníků bez telefonu i e-mailu`, popis: 'nedají se oslovit ani spárovat' });
    }
    return p;
}

/** Úrovně FofrTýmu (útrata za 12 měsíců) — prahy v `App\Support\SegmentyZakazniku`. */
export const UROVNE = {
    rekrut: { label: 'Rekrut', popis: 'člen, 5 % v Fofrech' },
    bojovnik: { label: 'Bojovník', popis: 'od 3 000 Kč za 12 měsíců' },
    strazce: { label: 'Strážce sklepení', popis: 'od 8 000 Kč za 12 měsíců, 7 % v Fofrech' },
};

export function UrovenOdznak({ uroven, isDark }) {
    const u = UROVNE[uroven];
    if (!u) return null;
    const vyrazna = uroven === 'strazce';
    return (
        <span title={u.popis} style={{
            fontSize: 10.5, fontWeight: 600, padding: '2px 8px', borderRadius: 999, whiteSpace: 'nowrap', display: 'inline-block', lineHeight: '16px',
            color: vyrazna ? SECTION_COLOR : 'var(--text-secondary)',
            background: vyrazna ? `${SECTION_COLOR}1A` : (isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.045)'),
            border: `1px solid ${vyrazna ? `${SECTION_COLOR}40` : (isDark ? 'rgba(255,255,255,0.10)' : 'var(--border-default)')}`,
        }}>{u.label}</span>
    );
}
